import {
  required,
  numericality
} from 'redux-form-validators'
import {
  priceAmountValidation,
  msrpAmountValidation,
  costAmountValidation,
  expiredTsValidation,
  amountValidationBy,
  lengthMax,
  subStationIdValidation,
  productNameLengthValidation,
  positivePriceValidation,
  cvsQtyLimitValidation,
  featureTitleValidation,
  giftCostValidation,
  offShelvedTsValidation,
  onShelvedTsValidation,
  productCopyValidation
} from './validations'
import { noEmoji, positiveInteger, onlyChineseValidation } from '../../../../../../lib/Validator'
import {
  WARRANTY_DESC_FIELD,
  WARRANTY_SCOPE_FIELD,
  WARRANTY_PERIOD_FIELD
} from '../../../../Shared'

export default {
  applicant: [
    required({ msg: '請輸入提案人' }),
    onlyChineseValidation({ msg: '請輸入中文全名' }),
    lengthMax('APPLICANT')
  ],
  subStationId: [
    required({ msg: '請輸入提案站別' }),
    subStationIdValidation
  ],
  expiredTs: [
    required({ msg: '請輸入審核期限' }),
    expiredTsValidation
  ],
  note: [
    lengthMax('NOTE')
  ],
  /** listing.XXXX **/
  'listing.onShelvedTs': [
    required({ msg: '請輸入開始日期' }),
    onShelvedTsValidation
  ],
  'listing.offShelvedTs': [
    required({ msg: '請輸入結束日期' }),
    offShelvedTsValidation
  ],
  'listing.purchaseQtyLimit': [
    required({ msg: '請輸入限購數量' }),
    positiveInteger,
    numericality({ '<=': 99, msg: '上限為99' })
  ],
  'listing.seoUrl': [
    required({ msg: '請輸入中文化網址' }),
    lengthMax('SEO_URL')
  ],
  'listing.price': [
    required({ msg: '請輸入購物中心售價' }),
    positiveInteger,
    positivePriceValidation,
    amountValidationBy('price'),
    priceAmountValidation
  ],
  'listing.cvsPurchaseQtyLimit': [
    required({ msg: '請輸入限購數量' }),
    positiveInteger,
    cvsQtyLimitValidation
  ],
  'listing.isDisplay': [
    required({ msg: '請選擇顯示設定' })
  ],
  'listing.featureTitle': [
    lengthMax('FEATURE_TITLE'),
    featureTitleValidation
  ],
  /** product.XXXX **/
  'product.copy': [
    required({ msg: '請輸入商品詳情' }),
    productCopyValidation()
  ],
  'product.name': [ // 注意! 修改這裏要檢查 SpecSettingModal.getSpecSettingProductNameValidation
    required({ msg: '請輸入賣場名稱' }),
    noEmoji({ msg: '請勿使用表情符號' }),
    productNameLengthValidation
  ],
  'product.safeStockQty': [
    required({ msg: '請輸入安全庫存量' }),
    positiveInteger,
    numericality({ '<=': 99, msg: '上限為99' })
  ],
  'product.msrp': [
    required({ msg: '請輸入市價' }),
    positivePriceValidation,
    amountValidationBy('msrp'),
    msrpAmountValidation
  ],
  'product.cost': [
    required({ msg: '請輸入進貨成本' }),
    giftCostValidation,
    positivePriceValidation,
    amountValidationBy('cost'),
    costAmountValidation
  ],
  'product.struDataAttrClusterId': [
    // 選擇規格表選項檢查
    required({ msg: '請選擇規格表' })
  ],
  'product.minPackingCount': [
    required({ msg: '請輸入最小包裝數' }),
    positiveInteger
  ],
  'product.shipType.id': [
    required({ msg: '請選擇配送方式' })
  ],
  [WARRANTY_SCOPE_FIELD]: [
    required({ msg: '請輸入保固範圍' }),
    noEmoji({ msg: '請勿使用表情符號' }),
    lengthMax('WARRANTY_SCOPE')
  ],
  [WARRANTY_DESC_FIELD]: [
    lengthMax('WARRANTY_DESC')
  ],
  [WARRANTY_PERIOD_FIELD]: [
    lengthMax('WARRANTY_SCOPE')

  ],
  'product.brand': [
    lengthMax('PRODUCT_BRAND')
  ],
  'product.model': [
    lengthMax('PRODUCT_MODEL')
  ],
  'product.brandId': [
    required({ msg: '請選擇商品品牌' })
  ]
}
